'use strict';

module.exports = function metrics() {
    var _metrics = {};

    document.addEventListener('site-speed-ebay.metricsData', function(evt) {
        var data = evt.detail;
        for(var key in data){
            if(key){
                _metrics[key] = data[key];
            }
        }
    });

    return {
        get: function() {
            var metricSet = _metrics;
            _metrics = {};
            return metricSet;
        }
    };
};
